import http from "../core/http";
const group = 'manageDock';

export const getInitialDataRequest =  async (data) => {
    return await http.post(`${group}/getInitialData`, data).then(res => res.data).catch(http.defaultCatch);
}

export const serveRequest = async (data) => {
    return await http.post(`${group}/serve`, data).then(res => res.data).catch(http.defaultCatch);
}

export const setStartTimeRequest = async (data) => {
    return await http.post(`${group}/setStartTime`, data).then(res => res.data).catch(http.defaultCatch);
}

export const setEndTimeRequest = async (data) => {
    return await http.post(`${group}/setEndTime`, data).then(res => res.data).catch(http.defaultCatch);
}

export const cancelRequest = async (data) => {
    return await http.post(`${group}/cancel`, data).then(res => res.data).catch(http.defaultCatch);
}



